import * as React from "react";
import styles from "./ContentView.scss";

interface IProps {
    id?: string;
    children?: React.ReactNode[] | React.ReactNode;
    className?: string;
    backgroundIsGray?: boolean;
}

class ContentView extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div id={this.props.id} className={`${styles.contentView} ${this.props.className} ${this.props.backgroundIsGray ? styles.gray : null}`}>
                <div className={styles.container}>{this.props.children}</div>
            </div>
        );
    }
}

export default ContentView;


// WEBPACK FOOTER //
// ./src/Components/ContentView/ContentView.tsx